import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-405530a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增角色")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "角色管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.addOrUpdateAdmin
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'auth_str')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString("共" + record.auths.length + "个权限 ") + _toDisplayString(text), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              onClick: ($event: any) => (_ctx.addOrUpdateAdmin(record)),
              style: {"margin":"5px"}
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}